//#region src/v2/components/layout/collapsible-section-heading-level.ts
/**
* Heading level for the title of a CollapsibleSection.
*
* A section assumes it sits directly below the page title and renders an `h2`.
* A parent that renders a title of its own above its sections provides a
* deeper level, so screen reader users hear the sections as subsections of
* that title rather than as its siblings.
*/
var COLLAPSIBLE_SECTION_HEADING_LEVEL = Symbol("collapsible-section-heading-level");
//#endregion
export { COLLAPSIBLE_SECTION_HEADING_LEVEL };

//# sourceMappingURL=collapsible-section-heading-level.js.map